module.exports = __webpack_public_path__ + "static/img/kjdy03.bcdb990.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/kjdy03.png
// module id = 129
// module chunks = 0